import type { IsoDate } from '@omnipresentgroup/design-system';
import { DateTime } from 'luxon';

export const isFutureDate = (isoDate: IsoDate | null | undefined) =>
  !!isoDate &&
  DateTime.fromISO(isoDate).startOf('day').toMillis() >
    DateTime.now().startOf('day').toMillis();
